export default {
  common: {
    login: "Iniciar sesión",
    userName: "Nombre de usuario",
    password: "Contraseña",
    rememberPassword: "Recordar",
    modifyPassword: "Modificar contraseña",
    accountRegister: "Registrar cuenta",
    pleaseInput: "Por favor ingrese",
    loginErrorCheckNamePassword: "Inicio de sesión fallido, por favor verifique el nombre de usuario y la contraseña",
    guest: "Invitado",
    superAdmin: "Super Administrador",
    logOut: "Cerrar sesión",
    inputUserName: "Ingrese el nombre de usuario",
    inputPassword: "Ingrese la contraseña",
    modifySuccessfully: "Se modificó con éxito la contraseña!",

    using: "Usando",
    toLogin: "para iniciar sesión",
    noOktaLoginUrl: "No hay URL de inicio de sesión de OKTA",
    uncheckSwitch: "Desmarque esta casilla para cambiar al modo de inicio de sesión regular",

    noADLoginUrl: "No hay URL de inicio de sesión de Azure AD"
  },
  register: {
    email: "Dirección de correo electrónico",
    confirmPassword: "Confirmar contraseña",
    register: "Registrar",
    emailRequire: "Se requiere correo electrónico",
    passwordRequire: "Se requiere contraseña",
    confirmPasswordRequire: "Se requiere confirmar la contraseña",
    passwordInconsistency: "Inconsistencia de contraseña",
    registeredSuccessfully: "¡Registrado con éxito!",
    jumpToLoginPage: "El sistema te redirigirá automáticamente a la página de inicio de sesión.",
    contactAdminActivate: "Póngase en contacto con el Administrador antes de iniciar sesión para activar la cuenta.",
    USER_EXISTS: "Cet utilisateur existe déjà",

    emailExists: "El correo electrónico ya existe",
    emailInconsistency: "Inconsistencia de correo electrónico",
    confirmEmailAddress: "Confirmar dirección de correo electrónico",
    emailAgain: "Introduzca el correo electrónico de nuevo",
    approvedCarrierOnly: "Solo para empleados autorizados de Carrier."
  },
  my: {
    about: "Acerca de",
    language: "Idioma",
    nomenclatureList: "Lista de nomenclatura",

    appName: "Nombre de la aplicación",
    version: "Versión",
    iecmFF: "iECM Marco de funcionalidad",
    paragraph1:
      "1. Los métodos de estimación de referencia cumplen plenamente con el Protocolo Internacional de Medición y Verificación del Rendimiento (IPMVP) y cada método se alinea con las directrices del IPMVP para garantizar una evaluación creíble y transparente del rendimiento energético.",
    paragraph2: "2. La biblioteca actual utiliza curvas de rendimiento basadas en condiciones AHRI.",
    paragraph3: "3. Se permiten entradas de rendimiento e-CAT certificado por AHRI para un enfriador post retrofit.",

    learningCenter: "Centro de aprendizaje",
    learningCenterDescription: "Acceda a videos tutoriales, manuales de usuario y guías de flujo de trabajo para ayudarle a utilizar iECM de manera más efectiva."
  }
}



// WEBPACK FOOTER //
// ./src/locale/login/es.js